import { useQuery } from '@tanstack/react-query';

import { getAccountOfferingBalances } from '@arrived/api_v2';
import { AccountId, AccountOfferingBalances } from '@arrived/models';

import { MAX_STALE_TIME, UseQueryOptions } from '../../queries.utils';
import { offeringBalancesKeyFn } from '../accounts.keys';

/**
 * The balances per offering for the given account.
 */
export function useGetAccountOfferingBalancesQuery(
  accountId: AccountId = 0,
  options?: UseQueryOptions<AccountOfferingBalances>
) {
  return useQuery(offeringBalancesKeyFn(accountId), () => getAccountOfferingBalances(accountId), {
    ...options,
    staleTime: options?.staleTime ?? MAX_STALE_TIME,
    enabled: !!accountId,
  });
}
